import { render, staticRenderFns } from "./PaperCenter.vue?vue&type=template&id=e47baa2a&scoped=true&"
import script from "./PaperCenter.vue?vue&type=script&lang=js&"
export * from "./PaperCenter.vue?vue&type=script&lang=js&"
import style0 from "./PaperCenter.vue?vue&type=style&index=0&id=e47baa2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47baa2a",
  null
  
)

export default component.exports